import EventEmitter from './EventEmitter.js'
import Experience from '../Experience.js'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
export default class Time extends EventEmitter
{
    constructor()
    {
        
        super()
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug
        this.sizes = this.experience.sizes
        this.camera = this.experience.camera
        // Setup
      
        this.start = Date.now()
        this.current = this.start
        this.elapsed = 0
        this.delta = 16
        this.mouse = new THREE.Vector2()
        
        window.requestAnimationFrame(() =>
        {
        
            this.tick()
          

        })
    }

    tick()
    {
        const currentTime = Date.now()
        this.delta = currentTime - this.current
        this.current = currentTime
        this.elapsed = this.current - this.start

        this.trigger('tick')

        window.requestAnimationFrame(() =>
        {
            this.tick()
        })
    }
   

   
}